var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8368 4.76282L14.0333 1.15106C13.9313 1.05424 13.7941 1 13.651 1H4.03514C2.91303 1 2 1.88261 2 2.96765V17.0323C2 18.1172 2.91289 19 4.03514 19H15.9649C17.087 19 18 18.1174 18 17.0323V5.1391C18 4.99751 17.9412 4.86197 17.8368 4.76282ZM14.1965 2.78445L16.1208 4.61176H14.3699C14.2743 4.61176 14.1965 4.5365 14.1965 4.44408V2.78445ZM15.9649 17.9453H4.03514C3.51456 17.9453 3.09086 17.5358 3.09086 17.0323V2.96765C3.09086 2.4642 3.51442 2.05469 4.03514 2.05469H13.1058V4.44408C13.1058 5.11809 13.6729 5.66644 14.37 5.66644H16.9091V17.0323C16.9091 17.5358 16.4856 17.9453 15.9649 17.9453Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1266 4.6L7.8382 8.78287H9.56487C9.85023 11.6573 8.71273 14.4174 5.58415 15.4C9.60866 15.4108 11.8886 12.206 12.66 8.78287H14.4151L11.1266 4.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/Request.732c6748c54701c430cfde5b3a0734f2.svg";
export { ForwardRef as ReactComponent };